import { Outlet } from "react-router";

export default function PublicLayout({ className = "" }: { className?: string }) {
  return (
    <div className={className}>
      <Outlet />
    </div>
  );
}
